module.exports = __webpack_public_path__ + "img/2080590.30dc1e0a.png";